// /modules/.../BuscarVehiculoPage.jsx
import React, { useState } from "react";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import DashboardLayout from "../../../layouts/DashboardLayout";
import BusquedaUnidadTab from "../components/BusquedaUnidadTab";
import BusquedaMasivaTab from "../components/BusquedaMasivaTab";

const TABS = ["Busqueda Unidad", "Busqueda Masiva"];

function TabPanel({ active, children }) {
  return (
    <Box role="tabpanel" hidden={!active} sx={{ display: active ? "block" : "none" }}>
      {children}
    </Box>
  );
}

const BuscarVehiculoPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <DashboardLayout>
      <Box
        sx={{
          width: "100%",
          minHeight: "calc(100vh - 64px)",
          bgcolor: "background.default",
          p: { xs: 1, md: 1.5 },
        }}
      >
        <Paper variant="outlined" sx={{ mb: 1, overflow: "hidden" }}>
          <Tabs
            value={tab}
            onChange={(_, value) => setTab(value)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 34,
              "& .MuiTab-root": {
                minHeight: 34,
                py: 0.5,
                px: 1.25,
                fontSize: 12,
                textTransform: "none",
              },
            }}
          >
            {TABS.map((label) => (
              <Tab key={label} label={label} />
            ))}
          </Tabs>
        </Paper>

        <TabPanel active={tab === 0}>
          <BusquedaUnidadTab />
        </TabPanel>
        <TabPanel active={tab === 1}>
          <BusquedaMasivaTab />
        </TabPanel>
      </Box>
    </DashboardLayout>
  );
};

export default BuscarVehiculoPage;
